import React, {Component} from 'react';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import SlateTable from '../../containers/SlateTable/SlateTable';
import SlateViewChip from '../../components/Shared/SlateViewChip';
import {fieldsTypes, slateTypes} from '../../config/constants';
import './style.css';
import theme from './../SlateViews/theme';

class SlateViewSearchResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchFinished: true,
    };

    this.active = null;
    this.columns = [
      {
        name: '',
        type: fieldsTypes.IMAGE,
        key: 'imageUUID',
        width: 84,
        index: 0,
      },
      {
        name: 'Title',
        type: fieldsTypes.TEXT,
        key: 'title',
        width: 384,
        index: 1,
      },
    ];
  }

  componentDidMount() {
    document.addEventListener(
      'scroll',
      (e) => this._handleScrollEvent(e),
      true,
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const searchStringFromUrl = this.props.match.params.searchString;

    // case - user reload page, it can define searchString only from url
    if (
      !this.props.searchString &&
      nextProps.currentAccount &&
      this.state.searchFinished
    ) {
      this.props.fetchSlatesForSearch({search: searchStringFromUrl || ''});
      this.setState({searchFinished: false});
    }
    if (
      this.props.searchString === nextProps.searchString &&
      !this.state.searchFinished
    ) {
      this.setState({searchFinished: true});
    }
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    !(isEqual(nextProps, this.props) && isEqual(nextState, this.state));

  render() {
    const {slates, searchResultRowCount, t} = this.props;
    const searchString = this.props.match.params.searchString;

    if (isEmpty(slates)) {
      return (
        <div>
          <div className="slate-view-empty">
            {`${t('slateViewSearch:emptyResult')} '${searchString}'`}
          </div>
        </div>
      );
    } else {
      return (
        <div className="inner-page slate-view">
          <div className="inner-page-header">
            <div className="inner-page-title">
              <span>
                {t('slateViewSearch:searchResultsHint')}
                {`'${searchString}'`}
              </span>
              <SlateViewChip
                type="slates"
                count={searchResultRowCount}
                className="slate-view-header-badge"
              />
            </div>
          </div>

          <div className="slate-view-container">
            <div className="slate-view-inner">
              <div className="slate-view-data">
                {slates && (
                  <SlateTable
                    onRowClickParentHandler={(e, uuid) =>
                      this.openSlatePane(uuid)
                    }
                    columns={this.columns}
                    slates={slates.map((slate) => ({
                      slateUUID: slate.uuid,
                      columns: this.columns.map((column) => ({
                        index: column.index,
                        value: slate[column.key],
                      })),
                    }))}
                    fixedHeader={true}
                    fixedHeaderHeight={36}
                    isExpandable={false}
                    isStaticRows={true}
                    withOrdering={false}
                    withFiltration={false}
                    withSorting={false}
                    useDragHandle={true}
                    rowHeightPreset="medium"
                    isImageExpandable={false}
                    rowCount={searchResultRowCount}
                    showEmptyImages={true}
                  />
                )}
              </div>

            </div>
          </div>
        </div>
      );
    }
  }

  // SCROLL HANDLING

  _handleScrollEvent = (e) => {
    let elem = e.target.classList;
    if (elem && elem.contains('body-grid') && this.active !== 'bodyGrid') {
      this.active = 'bodyGrid';
      e.target.focus();
    } else if (
      elem &&
      elem.contains('slate-pane-inner') &&
      this.active !== 'slatePane'
    ) {
      this.active = 'slatePane';
      e.target.focus();
    }
  };

  // SLATE PANE ACTIONS

  openSlatePane = (slateUUID) => {
    var slates = this.props.slates;
    var navList = slates ? slates.map(function(s) { return s.uuid; }) : [];
    this.props.openSlateInPane(slateUUID, { navList: navList, slateType: slateTypes.slate });
    if (this.gridBody) {
      this.gridBody.forceUpdate();
    }
  };
}

export default SlateViewSearchResult;
